import { createStyles, Theme } from '@material-ui/core/styles';

export default ({
  custom: {
    palette: { colorGrayishBlue },
  },
  palette: { text },
  spacing: { unit },
}: Theme) =>
  createStyles({
    showMoreButton: {
      borderRadius: '100%',
      height: '50%',
      minWidth: unit * 3,
      padding: unit / 2,
    },
    collapseDiv: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: unit * 4,
    },
    collapseDivider: {
      flexGrow: 1,
    },
    collapseButton: {
      borderRadius: unit * 2,
    },
    divider: {
      marginTop: unit * 4,
      marginBottom: unit * 4,
    },
    messageWrapper: {
      cursor: 'pointer',
      alignItems: 'flex-start',
      backgroundColor: colorGrayishBlue,
      position: 'relative',
      border: '1px',
      borderRadius: '15px 15px 15px 0px',
      color: text.primary,
      display: 'flex',
      flexDirection: 'column',
      fontWeight: 500,
      marginLeft: unit / 2,
      marginRight: unit * 2,
      maxWidth: '80%',
      padding: '10px 15px',
    },
    messageContent: {
      fontWeight: 'inherit',
      width: '100%',
      wordBreak: 'break-word',
      wordWrap: 'break-word',
      '& a': {
        color: 'inherit !important',
      },
    },
    outbound: {},
    pullBottom: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
    },
    root: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: 5,
    },
    wrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
  });
